module.exports = __webpack_public_path__ + "img/img_hezuo_12@2x.1de30881.png";